<div class="ignore-darkreader" id='{{chartId}}'></div>
